import { useEffect } from 'react';
var useDocumentTitle = function useDocumentTitle() {
    useEffect(function () {
        var _process$env$REACT_AP;
        document.title = (_process$env$REACT_AP = process.env.REACT_) !== null && _process$env$REACT_AP !== void 0 ? _process$env$REACT_AP : 'Common Services';
    }, []);
};
export default useDocumentTitle;
